export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.基本信息': '基本信息',
  'menu.基本信息.服务片区': '服务片区',
  'menu.基本信息.新建片区': '新建片区',
  'menu.基本信息.编辑片区': '编辑片区',
  'menu.基本信息.商户信息': '商户信息',
  'menu.基本信息.新建商户': '新建商户',
  'menu.基本信息.编辑商户': '编辑商户',
  'menu.基本信息.查看商户': '查看商户',
  'menu.基本信息.新增签订合同': '新增签订合同',
  'menu.基本信息.编辑合同': '编辑合同',
  'menu.基本信息.查看合同': '查看合同',
  'menu.基本信息.新建人员': '新建人员',
  'menu.基本信息.编辑人员': '编辑人员',
  'menu.基本信息.运营信息': '运营信息',
  'menu.服务片区': '服务片区',
  'menu.新建片区': '新建片区',
  'menu.商户信息': '商户信息',
  'menu.新建商户': '新建商户',
  'menu.编辑商户': '编辑商户',
  'menu.查看商户': '查看商户',
  'menu.新增签订合同': '新增签订合同',
  'menu.编辑合同': '编辑合同',
  'menu.查看合同': '查看合同',
  'menu.新建人员': '新建人员',
  'menu.编辑人员': '编辑人员',
  'menu.运营信息': '运营信息',
  'menu.新建清运记录': '新建清运记录',
  'menu.编辑清运记录': '编辑清运记录',
  'menu.清运记录': '清运记录',
  'menu.清运记录.清运记录': '清运记录',
  'menu.清运记录.新建清运记录': '新建清运记录',
  'menu.到期提醒': '到期提醒',
  'menu.对账': '对账',
  'menu.对账.对账列表': '对账列表',
  'menu.对账.手动对账': '手动对账',
  'menu.对账.查看': '查看',
  'menu.对账.新建手动对账': '新建手动对账',
  'menu.对账.去对账': '去对账',
  'menu.对账列表': '对账列表',
  'menu.手动对账': '手动对账',
  'menu.开票': '开票',
  'menu.开票.开票列表': '开票列表',
  'menu.开票.手动开票': '手动开票',
  'menu.开票.申请开票': '申请开票',
  'menu.开票.查看开票': '查看开票',
  'menu.开票.发起手动开票': '发起手动开票',
  'menu.开票列表': '开票列表',
  'menu.手动开票': '手动开票',
  'menu.回款': '回款',
  'menu.回款.回款列表': '回款列表',
  'menu.回款.手动回款': '手动回款',
  'menu.回款.完成回款': '完成回款',
  'menu.回款.查看': '查看',
  'menu.回款.新建手动回款记录': '新建手动回款记录',
  'menu.回款列表': '回款列表',
  'menu.手动回款': '手动回款',
  'menu.现结回款': '现结回款',
  'menu.充值': '充值',
  'menu.充值.充值': '充值',
  'menu.充值.查看': '查看',
  'menu.卡余额提醒': '卡余额提醒',
  'menu.消纳': '消纳',
  'menu.消纳.消纳': '消纳',
  'menu.消纳.新建消纳': '新建消纳',
  'menu.消纳.编辑': '编辑',
  'menu.消纳.查看': '查看',
  'menu.统计分析': '统计分析',
  'menu.规则设置': '规则设置',
  'menu.系统设置': '系统设置',
  'menu.系统设置.成员管理': '成员管理',
  'menu.系统设置.成员列表': '成员列表',
  'menu.系统设置.添加成员': '添加成员',
  'menu.系统设置.编辑成员': '编辑成员',
  'menu.系统设置.查看成员': '查看成员',
  'menu.系统设置.角色与权限': '角色与权限',
  'menu.系统设置.角色列表': '角色列表',
  'menu.系统设置.添加角色': '添加角色',
  'menu.系统设置.编辑角色': '编辑角色',
  'menu.系统设置.查看角色': '查看角色',
  'menu.成员管理': '成员管理',
  'menu.成员列表': '成员列表',
  'menu.添加成员': '添加成员',
  'menu.编辑成员': '编辑成员',
  'menu.查看成员': '查看成员',
  'menu.角色与权限': '角色与权限',
  'menu.角色列表': '角色列表',
  'menu.添加角色': '添加角色',
  'menu.编辑角色': '编辑角色',
  'menu.查看角色': '查看角色',
  'menu.订单管理': '订单管理',
  'menu.订单管理.订单管理': '订单管理',
  'menu.订单管理.编辑': '编辑',
  'menu.订单管理.查看': '查看',
};
